import capitalize from '../utils/capitalize';

export interface ISlot {
  id: string | number;
  start: Date;
  end: Date;
  availabilities: number;
  remaining: number;
  message: string;
}

export default class Slot implements ISlot {
  id: string | number = '';
  start: Date = new Date();
  end: Date = new Date();
  availabilities: number = 1;
  remaining: number = 1;
  message: string = '';

  constructor(obj: Partial<ISlot>) {
    Object.assign(this, obj);
  }

  static createFromEntity(obj: Partial<any>) {
    return new Slot({
      id: obj.id,
      start: new Date(obj.start),
      end: new Date(obj.end),
      availabilities: obj.availabilities,
      remaining: obj.remaining,
      message: obj.message
    });
  }

  getStartDayString() {
    let start = this.start;

    return capitalize(
      start.toLocaleDateString('fr-FR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    );
  }

  getStartHourString() {
    let start = this.start;

    return `${String(start.getHours()).padStart(2, '0')}h${String(
      start.getMinutes()
    ).padStart(2, '0')}`;
  }
}
